import lazySizes from 'lazysizes';

import ads from './components/ads/ads';
import dataLayerEvents from './components/dataLayerEvents/dataLayerEvents';
import imageMediaComponent from './components/ImagesMediaComponent/imageMediaComponent';

// Init modules that require DOM AND assets to be fully loaded here
export function onPageFullyLoaded() {
    // akcelo prebid must be fully loaded before loading adverts
    ads.init();
    // images or css loading after the js is executed
    imageMediaComponent.init();
}

// Init modules that only need the DOM to be ready here (assets, images and CSS might not be fully loaded here)
export function onDomReady() {
    dataLayerEvents.init();

    // page is optimized for fast onload event
    Object.assign(lazySizes.cfg, {
        loadMode: 2,
    });

    const jcsBadges = document.querySelectorAll('[data-test-quiz-completed-badge-id]');
    const thematicProgressBar = document.getElementById('test-quiz-progress-bar-thematic');
    if (jcsBadges.length !== 0 || thematicProgressBar !== null) {
        import(
            './components/testQuiz/userInfoComponent'
        ).then((component) => component.default.init());
    }

    const backLinkComponent = document.querySelectorAll('[data-back-link]');
    if (backLinkComponent.length !== 0) {
        import(
            './components/backLinkComponent/backLinkComponent'
        ).then((component) => component.default.init());
    }

    const chartComponent = document.querySelectorAll('[data-chart]');
    if (chartComponent.length !== 0) {
        import(
            './components/chart/chartComponent'
        ).then((component) => component.default.init());
    }

    const seeMoreComponent = document.querySelectorAll('[data-see-more-container]');
    if (seeMoreComponent.length !== 0) {
        import(
            './components/seeMoreComponent/seeMoreComponent'
        ).then((component) => component.default.init());
    }

    import(
        './components/modal/shareAndCopyLinkComponent'
    ).then((component) => component.default.init());

    const uploadComponent = document.querySelectorAll('[data-component="upload-file"]');
    if (uploadComponent.length !== 0) {
        import(
            './components/uploadComponent/uploadComponent'
        ).then((component) => component.default.init());
    }

    const modalComponent = document.querySelectorAll('[data-modal-name]');
    if (modalComponent.length !== 0) {
        import(
            './components/modal/modalComponent'
        ).then((component) => component.default.init());
    }

    const tabsComponent = document.querySelectorAll('[data-component=tabs]');
    if (tabsComponent.length !== 0) {
        import(
            './components/tabs/tabs'
        ).then((component) => component.default.init());
    }

    const toasterComponent = document.getElementById('toaster-item');
    if (toasterComponent !== null) {
        import(
            './components/toaster/toaster'
        ).then((component) => component);
    }

    const toggleComponent = document.querySelectorAll('[data-toggle-target]');
    if (toggleComponent.length !== 0) {
        import(
            './components/toggle/toggle'
        ).then((component) => component.default.init());
    }

    const anchorTargetPolicyComponent = document.querySelectorAll('[data-component=anchor-target-policy]');
    if (anchorTargetPolicyComponent.length !== 0) {
        import(
            './components/anchorTargetPolicyComponent/anchorTargetPolicyComponent'
        ).then((component) => component.default.init());
    }

    const liverampComponent = document.querySelectorAll('[data-component=liveramp]');
    if (liverampComponent.length !== 0) {
        import(
            './components/liverampComponent/liverampComponent'
        ).then((component) => component.default.init());
    }

    const hideOnLoadComponent = document.querySelectorAll('[data-hide-onload]');
    if (hideOnLoadComponent.length !== 0) {
        import(
            './components/hideOnLoadComponent/hideOnLoadComponent'
        ).then((component) => component.default.init());
    }

    const ganMapComponent = document.querySelectorAll('[data-map-display]');
    if (ganMapComponent.length !== 0) {
        import(
            './components/gan/mapComponent'
        ).then((component) => component.default.init());
    }

    const truncateTextComponent = document.querySelectorAll('[data-text-truncate]');
    if (truncateTextComponent.length !== 0) {
        import(
            './components/truncateTextComponent/truncateTextComponent'
        ).then((component) => component.default.init());
    }

    const leafletComponent = document.querySelectorAll('[data-leaflet]');
    if (leafletComponent.length !== 0) {
        import(
            './components/leaflet/leaflet'
        ).then((component) => component.default.init());
    }

    const comparatorComponent = document.querySelector('[data-component="comparator"]');
    if (comparatorComponent !== null) {
        import(
            './components/comparatorComponent/comparatorComponent'
        ).then((component) => component.default.init());
    }

    const ospNavbarComponent = document.querySelector('#main-osp-navbar');
    if (ospNavbarComponent !== null) {
        import(
            './components/osp/navbarComponent'
        ).then((component) => component.default.init());
    }
}
